import axios from "axios"
import { bidListFail, bidListRequest, bidListSuccess, bidPaidFail, bidPaidRequest, bidPaidSuccess, bidPlaceFail, bidPlaceRequest, bidPlaceSuccess, bidProductFail, bidProductRequest, bidProductSuccess } from "../reducers/bidReducers"

// Function to get CSRF token from cookie
const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === (name + '=')) {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
}

const createAPIinstance = () => {
    const csrfToken = getCsrfToken();
    return axios.create({
        baseURL: `${process.env.REACT_APP_BASE_API_URL}/api/users/bids`,
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': csrfToken
        },
        withCredentials: true
    })
}

// Get all bids for a specific product
export const listBids = (productID) => async (dispatch) => {
    try {
        dispatch(bidListRequest())

        const api = createAPIinstance()
        const { data } = await api.get(`/product/${productID}/`)
        dispatch(bidListSuccess(data))
    } catch (error) {
        dispatch(bidListFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}

// Get all bids for the current user
export const getUserBids = () => async (dispatch) => {
    try {
        dispatch(bidListRequest())

        const api = createAPIinstance()
        const { data } = await api.get('/')
        dispatch(bidListSuccess(data))
    } catch (error) {
        dispatch(bidListFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}

export const placeBid = (bid) => async (dispatch) => {
    try {
        dispatch(bidPlaceRequest())

        const api = createAPIinstance()
        const { data } = await api.post('/', bid)

        dispatch(bidPlaceSuccess(data))
    } catch (error) {
        dispatch(bidPlaceFail(
            error.response && error.response.data.bid && error.response.data.bid.detail ?
            error.response.data.bid.detail :
            (error.response && error.response.data.detail ?
             error.response.data.detail : error.message)
        ))
    }
}

export const calculateBidPaid = (bid) => async (dispatch) => {
    try {
        dispatch(bidPaidRequest())

        const api = createAPIinstance()
        const { data } = await api.post('/calculate-payment/', bid)

        dispatch(bidPaidSuccess(data))
    } catch (error) {
        dispatch(bidPaidFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}

export const productBids = (productID) => async (dispatch) => {
    try {
        dispatch(bidProductRequest())
        
        const api = createAPIinstance()
        const { data } = await api.get(`/product/${productID}`)
        
        dispatch(bidProductSuccess(data))
    } catch (error) {
        dispatch(bidProductFail(
            error.response && error.response.data.detail ?
            error.response.data.detail :
            error.message
        ))
    }
}
